import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="bg-white py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          Terms and Conditions
        </h1>
        {/* <p className="mt-4 text-lg text-gray-600">
          Effective Date: {new Date().toLocaleDateString()}
        </p> */}
      </div>

      <div className="prose prose-lg mx-auto">
        <p>
          These terms and conditions constitute the complete and detailed service agreement
          between you (the Customer) and us (Envipro Solutions Pty Ltd) for the provision of
          services.
        </p>
        <p>
          Accessing and utilizing the mobile phone applications of the Website is governed by the
          terms and conditions specified in this agreement (hereinafter referred to as the
          "Terms").
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Information</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            The details you provide on the Envipro Solutions Pty Ltd website or mobile
            application will be regarded as accurate and will remain unaltered throughout
            the duration of the service provision.
          </li>
          <li>
            If the information you provide is not accurate, it may lead to discrepancies in the
            quoted price for the service. Consequently, the consumer, occupant, or agent
            will be required to either cover the difference in pricing or forgo the service
            altogether.
          </li>
          <li>
            The quotation you have received, derived from the information supplied, remains
            an estimate and is subject to change on the day of assessment, depending on
            the property's size and condition.
          </li>
          <li>
            If you cancel a service due to the submission of inaccurate information, a
            booking fee will be incurred if the cleaners, subcontractor, or associate have
            already been dispatched to the designated location, and the client opts to
            terminate the service prior to its commencement.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Quote</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            The quotations provided are derived from the information you have submitted.
          </li>
          <li>
            The provided quotes are based on a standard room size; should the room exceed
            this standard dimension; additional charges may apply. These charges will be
            determined by the duration required to complete the service efficiently and
            promptly.
          </li>
          <li>
            We will not impose any additional charges unless they are recognized and agreed
            upon by the consumer, occupant, agent, and Envipro Solutions Pty Ltd.
          </li>
          <li>
            All quotes will be communicated via email or telephone, and acceptance will be
            confirmed by acknowledging the specified date and time.
          </li>
          <li>
            Each quotation remains valid for a specified duration, contingent upon our
            availability.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Payments</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Payment must be completed prior to the provision of services, either through an
            online method or via direct transfer.
          </li>
          <li>
            The payment regulations are applicable to everyone, and if the payment is not
            received by the day before the scheduled service, we reserve the right to
            terminate your service. Additionally, a cancellation fee of up to $150 may be
            imposed, contingent upon the specific service requested.
          </li>
          <li>
            Refunds have its set of rules, which will be followed in case of any services you
            don't get.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Appointment</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            The consumers/occupants/agents should understand that unexpected situation
            may result in the termination of service.
          </li>
          <li>
            All cancelled services will be rearranged.
          </li>
          <li>
            If the consumer wishes to cancel service after a reschedule made by Envipro
            Solutions Pty Ltd the consumer will not be charged for it.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">User Profile</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            You will receive a unique username and password associated with your User
            Profile. These credentials are exclusively yours and cannot be shared with
            others. You bear full responsibility for all information submitted or
            communicated through the Booking System by anyone utilizing your username
            and password, as well as for any payments owed for Cleaning Services obtained
            through the Booking System by individuals using your credentials. It is imperative
            that you inform us immediately of any security breaches concerning your
            username and password.
          </li>
          <li>
            By using the Booking System, you affirm that you are a minimum of 18 years old
            and have the legal capacity to engage with the system in compliance with these
            Terms. Furthermore, you acknowledge that all information you provide while
            utilizing the Website or mobile applications, as well as the Booking System, will
            consistently be truthful and precise.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Termination</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            If a consumer wishes to withdraw or rearrange the service before 24 hours of the
            booked day, then we will charge you a fee of up to $100.
          </li>
          <li>
            If any consumer cancels or rearrange a service within the 2 hours of any service
            initiation, there may be an extra charge for travelling expenses and bookings
            expenses; it depends on time and date.
          </li>
          <li>
            If the consumer cancels the service once the service has been initiated, then you
            may have to pay an extra charge for the work including travel expenses and
            booking fees.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Offering Service</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            The services we provide to you are executed with the utmost care and
            professionalism by our team of experts.
          </li>
          <li>
            Clients are encouraged to facilitate the cleaning process by ensuring that their
            personal belongings and furniture are removed from the designated cleaning
            area. Should the removal of items extend beyond one hour, an additional fee may
            be incurred.
          </li>
          <li>
            We may even charge a fee to cover all the operating cost if we must pick up and
            or drop off keys more than 5 km from the area where the service is to be given.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Guarantee</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            We assure you that our team will arrive at the work site and deliver the service
            until the customer, tenant, or agent is completely satisfied with the results of our
            efforts.
          </li>
          <li>
            This guarantee is only applicable to the services that include in the main package
            along with all the extras that were agreed for. Any work that wasn't meant for or
            agreed to be offered by us is not mentioned in the service.
          </li>
          <li>
            There will be no full refunds once the service is finished; our guaranteed policy
            assures that our cleaner or subcontractor will be there on the site until the
            customer is satisfied.
          </li>
          <li>
            This guarantee is only applicable if we are contacted within 2 days (48 hours)
            after the service was given.
          </li>
          <li>
            Our bond cleaning guarantee gets void if the property is occupied by someone
            and used even if the 2 days guarantee is active.
          </li>
          <li>
            Please note that the guarantee doesn't apply to situations in tear and wear. If a
            wall or carpets are damaged, it will not be restored by any means, since all we do
            is cleaning and not painting or carpet dyeing.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">Refund/Cancellation</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            If you cancel your booking 5 days before the booked date, you will not be charged
            a fee for cancellation.
          </li>
          <li>
            If you cancel your booking within 24 hours from the booking date, then we will
            charge you a fee of upto $100.
          </li>
          <li>
            We hold all rights to cancel the job if we deem the condition of the property is
            dangerous for the safety, health or well-being of our staff or if we are unable to
            access the property as agreed. Same day cancellation fees will apply.
          </li>
          <li>
            We reserve the right to re-schedule or cancel any Service if the property is not as
            described either in condition or size, or if unexpected circumstances occur.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermsAndConditions;